<template>
    <footer class="footer page-footer">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <ul class="list-unstyled list-inline">
<!--                    <ul class="list-unstyled list-inline" v-if="showFooterLinks">-->
                        <li class="list-inline-item">
                          <router-link :to="{name: 'Terms'}">Terms &amp; conditions</router-link>
                        </li>
                        <li class="list-inline-item">
                          <router-link :to="{name: 'Privacy'}">Privacy policy</router-link>
                        </li>
                        <li class="list-inline-item">
                            <router-link v-if="carrier !== 'likewize-au'" :to="{name: 'Faqs'}">Help</router-link>
                            <a v-if="carrier === 'likewize-au'" href="https://likewizerepair.com.au/help">Help</a>
                        </li>
                    </ul>
                    <p>
                        &copy; {{currentYear}} {{ carrierDetails.address }}
                    </p>
                    <ul class="list-unstyled list-inline mb-0">
                        <li class="list-inline-item" v-if="carrierDetails.registrationDetails">
                            {{ carrierDetails.registrationDetails }}
                        </li>
                        <li class="list-inline-item" v-if="allowsInStoreBooking">
                            <router-link :to="{name: 'storeSearch'}" target="_blank">Store Login</router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
import {mapGetters} from "vuex";

export default {
    data() {
        return {
            currentYear: new Date().getFullYear()
        };
    },

    computed: {
        ...mapGetters([
            'carrier',
            'carrierDetails',
            'allowsStoreDropOff',
            'allowsInStoreBooking',
            'countryCodeSetting'
        ]),

        // showFooterLinks() {
        //     if (this.carrierDetails.termsLink ||
        //         this.carrierDetails.privacyLink ||
        //         this.carrier === 'vodafone') {
        //         return true;
        //     }
        //
        //     return false;
        // }
    }
};
</script>

<style scoped>

</style>
